import { render, staticRenderFns } from "./editRight.vue?vue&type=template&id=3c318bce"
import script from "./editRight.vue?vue&type=script&lang=js"
export * from "./editRight.vue?vue&type=script&lang=js"
import style0 from "./editRight.vue?vue&type=style&index=0&id=3c318bce&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports